import React, { useState } from "react";
import {
  DateInput,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../../components";
import styles from "./MaintenanceLog.module.css";
import { Table } from "antd";
import ModalComponent from "../../../../../../components/modal/ModalComponent";

const MaintenanceLog = () => {
  const [Modal, setModal] = useState(false);
  const [date, setDate] = useState("");
  const [LogBy, setLogBy] = useState("");
  const [Notes, setNotes] = useState("");

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: "By",
      dataIndex: "By",
      key: "By",
    },
    {
      title: "Timestamp",
      key: "Timestamp",
      dataIndex: "Timestamp",
    },
    {
      title: "Notes",
      key: "Notes",
      dataIndex: "Notes",
    },
  ];

  const data = [
    {
      Date: "2025-08-15",
      By: "John Smith",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "Michael Brown",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "Robert Johnson",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "David Wilson",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
  ];
  return (
    <div>
      <SubmitButton
        btnContainerClass={styles.SubmitButtonDiv}
        title={"New Log"}
        btnClass={styles.SubmitButton}
        style={{ marginTop: "10px" }}
        primary
        onClick={() => setModal(true)}
      />
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="No"
        />
      </div>

      <ModalComponent
        open={Modal}
        onClickOkButton={() => {
          setModal(false);
        }}
        onClickCancelButton={() => setModal(false)}
        onCancel={() => setModal(false)}
        className={styles.modalCont}
        title={"New Log"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"Log"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => {
          setModal(false);
        }}
      >
        <div className={styles.Row}>
          <DateInput
            label={"Date"}
            placeholder={"6/4/2025"}
            value={date}
            className={styles.DateInput}
            onChange={setDate}
          />
          <InputField
            className={styles.inputNew}
            label={"By"}
            placeholder={"John Smith"}
            value={LogBy}
            onChange={(e) => setLogBy(e.target.value)}
          />
        </div>
        <InputField
          className={styles.Notesinput}
          label={"Notes"}
          textArea
          rows={3}
          placeholder={"Changed Nut bolts.."}
          value={Notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </ModalComponent>
    </div>
  );
};

export default MaintenanceLog;
